import { ReactNode } from 'react';

import logoWhite from 'assets/svg/logo-white.svg';

import * as S from './styles';

/**
 * The flow's dark full-bleed screen: background, glow and the logo.
 *
 * Every screen the flow can be showing while it works — step 0 and the loading
 * state — renders through this, so a reload cannot land the member on a layout
 * that looks like a different site.
 *
 * The logo is the only chrome: the marketing header's nav and "Join now" belong to
 * someone who has not started, and the flow has no use for them.
 */

export type FlowScreenProps = {
  children: ReactNode;
};

const FlowScreen = ({ children }: FlowScreenProps) => (
  <S.Overlay>
    <S.Bloom aria-hidden />

    <a href="https://savings.club" aria-label="Savings.Club home">
      <S.Logo src={logoWhite} alt="Savings.Club" />
    </a>

    {children}
  </S.Overlay>
);

export default FlowScreen;
